<template>
  <div>
    <!-- 信息变更列表 -->
    <Modal v-model="ctrl" :width="800" :footer-hide="true" :mask-closable="false" @on-cancel="cancel(false)">
      <div slot="header" style="font-weight: 700; font-size: 18px">
        {{ data.title }}
      </div>
      <div v-if="ctrl" class="modal-content">
        <div class="notice-content" v-html="data.text"></div>
        <div class="notice-attachment">
          <p>【附件】</p>
          <div>
            <file-upload :default-list="data.attachmentList || []" :upload-config="{ readOnly: true }" />
          </div>
        </div>
      </div>
      <Row style="text-align: center;">
        <Button type="primary" :disabled="buttonLoading" @click="submit(data.id)">{{ buttonLoading ? `请阅读(${seconds}s)` : '我已阅读' }} </Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ctrl: false,
      isSubmit: false,
      buttonLoading: false,
      seconds: 10,
      data: {},
      table: { // 表格数据接口的相关参数
        pageSize: 10,
        pageNum: 1,
        totalRecords: 1
      }
    }
  },
  computed: {
    updateCtrl() {
      return this.$store.state.hasInfo
    }
  },

  watch: {
    updateCtrl(val) {
      if (val) {
        this.getData(true)
      } else {
        this.ctrl = false
      }
    }
  },

  methods: {
    getData(isFirst) {
      const url = '/business/bulletin/popup'
      const ajaxData = {
        current: this.table.pageNum,
        size: this.table.pageSize
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code === 0 && res.data.records.length) {
          if (isFirst) { // 第一次请求时才需要打开弹窗
            this.ctrl = true
          }
          this.data = res.data.records && res.data.records[0]
          this.table.totalRecords = res.data.total
          this.startCountdown()
        } else {
          this.cancel(false)
          this.data = {}
          this.table.totalRecords = 0
        }
      })
    },
    startCountdown() {
      this.seconds = 10
      this.buttonLoading = true
      this.timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--
        } else {
          clearInterval(this.timer)
          this.buttonLoading = false
          this.seconds = 10 // 重置为初始值
        }
      }, 1000)
    },
    submit(id) {
      const url = `/business/bulletin/read/${id}`
      this.isSubmit = true
      this.$patch(url).then(res => {
        this.isSubmit = false
        if (res.code === 0) {
          this.$Message.success('操作成功')
          this.getData()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    cancel(bool) {
      this.ctrl = false
      this.$store.commit('setHasInfo', false)
      if (bool) {
        this.getData()
      }
    }
  }
}

</script>
<style scoped lang='scss'>
.modal-content {
  overflow-y: auto;
  padding: 16px 26px;
  margin: -16px;
  .notice-content {
    margin: 15px 0;
  }
  .notice-attachment {
    p {
      font-weight: 600;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/home/announcementTip.vue